"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
const ConfirmSMSCode = (props) => {
    const { createPasswordStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const handlePasswordValue = (value, id) => {
        createPasswordStore.getValue(value, id);
    };
    const submitMfaCode = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        props.setLoading(true);
        yield createPasswordStore.submitMfaCode().catch((error) => {
            popupStore.setAlertData('MFA code entered is expired or invalid. Please contact Support for a new code.', true);
            props.setLoading(false);
        });
        props.setLoading(false);
    });
    return (react_1.default.createElement("div", { className: "global-container" },
        react_1.default.createElement("form", { className: "config-mfa-form", onSubmit: submitMfaCode },
            react_1.default.createElement("div", { className: "confirm-phone-mfa" },
                react_1.default.createElement("h3", null, "Confirm Phone MFA"),
                react_1.default.createElement("p", null,
                    "We have texted a code to ",
                    react_1.default.createElement("strong", null, createPasswordStore.formattedPhoneNumber),
                    ". Please enter that code in the space below."),
                react_1.default.createElement("p", { className: 'disclaimer' }, "NOTE: MFA codes expire after 15 minutes."),
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'code', onChange: handlePasswordValue, label: 'Code', required: true, errorMessage: createPasswordStore.codeError, autoComplete: "off", assistiveText: '', autoFocused: true }),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: props.loading }, "Submit Code")))));
};
exports.default = (0, mobx_react_1.observer)(ConfirmSMSCode);
